"use client";

import Button from "@/components/button";
import { logger } from "@/utils/logger";
import { useTranslations } from "next-intl";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations("common");

  useEffect(() => {
    logger.error(error);
  }, [error]);

  return (
    <html>
      <body>
        <div className="w-screen h-screen bg-BlueBG flex items-center justify-center">
          <div className="shadow-uploadModal border border-white bg-Black100 w-full max-w-[735px] rounded-[32px] p-16">
            <h1 className="text-white font-extrabold text-center text-[36px] leading-tight">
              {t("500.title")}
            </h1>
            <hr className="border-2 border-Blue100 rounded-sm my-4 mx-[100px]" />
            <p className="text-white mb-[16px] text-2xl text-center ">
              {t("500.description")}
            </p>
            <div className="w-[38%] mx-auto">
              <Button
                label={t("500.button")}
                icon="arrow-left-2"
                iconPosition={"left"}
                type="button"
                variant="primary"
                size="small"
                link={`${process.env.NEXT_PUBLIC_BASE_URL}/`}
              />
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
